import { pages } from '../util/global-methods';

const routes = [
  // {
  //   path: 'support', component: pages('support'), props: true, redirect: 'support/faq',
  //   children: [
  //     {path: 'faq', component: pages('support/faq'), props: true, meta: {name: 'faq'}},
  //     {path: 'notice', component: pages('support/notice'), props: true, meta: {name: 'notice'}},
  //     {path: 'notice/details/:key', component: pages('support/notice-details'), props: true, meta: {name: 'notice'}},
  //     {path: 'inquiry', component: pages('support/inquiry'), props: true, meta: {name: 'inquiry', auth: true}}
  //   ]
  // }
];

export default routes;
